import script from "./reservation-detail.vue?vue&type=script&setup=true&lang=ts"
export * from "./reservation-detail.vue?vue&type=script&setup=true&lang=ts"

import "./reservation-detail.vue?vue&type=style&index=0&id=9971016a&lang=scss&scoped=true"

import exportComponent from "D:\\work\\kaifengzimaoqu\\wt_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9971016a"]])

export default __exports__